import TurndownService from "turndown";

// `*` instead of the default `_` for italic: Kramdown (which renders this
// content server-side) treats intraword underscores as literal, so `_` would
// silently drop italic formatting on text like "well*emphasis*ed" the moment
// it touches a word character with no surrounding space. `*` has no such gap.
const turndownService = new TurndownService({
  emDelimiter: "*",
  bulletListMarker: "-",
});

export const htmlToMarkdown = (html: string): string =>
  turndownService.turndown(html);
